import "./paymentsMetrics.scss";
import { Flex, Skeleton } from "antd";

/** Displays a loading screen in the shape of the metrics cards that would be displayed. */
export const IntegratedMetricsLoading = ({ isMarketing }: { isMarketing?: boolean }) => (
    <>
        {/* if on marketing page, have 2 paragraph lines for loading as well */}
        {isMarketing && (
            <Flex className="marketing-metrics-loading-wrapper" gap={16} vertical>
                <Skeleton.Node className="marketing-metrics-loading" />
                <Skeleton.Node className="marketing-metrics-loading" />
            </Flex>
        )}
        <Flex className="metrics-cards-loading-wrapper">
            <Skeleton.Node className="ant-card metrics-cards metrics-total-account-balance metrics-cards-loading" />
            <Skeleton.Node className="ant-card metrics-cards metrics-cards-loading" />
            <Skeleton.Node className="ant-card metrics-cards metrics-cards-loading" />
            <Skeleton.Node className="ant-card metrics-cards metrics-cards-loading" />
            <Skeleton.Node className="ant-card metrics-cards metrics-cards-loading" />
        </Flex>
    </>
);

/** Displays a loading screen in the shape of the non integrated metrics cards that would be displayed. */
export const NonIntegratedMetricsLoading = () => (
    <Flex className="metrics-cards-loading-wrapper">
        <Skeleton.Node className="ant-card metrics-cards metrics-cards-loading" />
        <Skeleton.Node className="ant-card metrics-cards metrics-cards-loading" />
    </Flex>
);
